import { createFileRoute } from '@tanstack/react-router'
import { requireSection } from '../../../features/settings/guards'
import { TypographySection } from '../../../features/settings/typography-section'

export const Route = createFileRoute('/_app/settings/typography')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'typography'),
  component: TypographySection,
})
